
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./editor.cjs.production.min.js')
} else {
  module.exports = require('./editor.cjs.development.js')
}
